
<div class="page" data-testid="order-confirmation">
  <div class="receipt-header">
    <img class="icon-md" [src]="statusIcon | themeSource" />
    <span>{{ statusMessage | translate }}</span>
    <span>{{ order.table.name }} | {{ order.created_at | date:'shortTime' }}</span>
    <h6>{{ 'ORDER.ORDER' | translate }} #{{ order.code.substr(4) }}</h6>
  </div>

  <div class="order-details border-line">
      @for (line of lines; track line.id) {
        <app-cart-line-item [line]="line" [readOnly]="true">
        </app-cart-line-item>
      }
  </div>

  <div class="order-summary">
    @if (isPaid) {
      <div>
        <span>{{ 'ORDER.SUBTOTAL' | translate }}</span>
        <span>{{ order.total_price_without_discount | currencySpace }}</span>
      </div>
      @if (order.promo?.amount) {
        <div>
          <span>{{ 'PAY_AT_TABLE.PROMO' | translate }}</span>
          <span>- {{ order.promo.amount | currencySpace }}</span>
        </div>
      }
      @if (order.discount_amount) {
        <div>
          <span>{{ 'PAY_AT_TABLE.DISCOUNT' | translate }}</span>
          <span>- {{ order.discount_amount | currencySpace }}</span>
        </div>
      }
      @if (order.fee_amount) {
        <div>
          <span>{{ 'COMMON.FEES' | translate }}</span>
          <span>{{ order.fee_amount | currencySpace }}</span>
        </div>
      }
      @if (+order.tip_amount) {
        <div class="border-line">
          <span>{{ 'TIP.TIP' | translate }}</span>
          <span>{{ +order.tip_amount | currencySpace }}</span>
        </div>
      }
    }

    <div>
      <span>{{ 'ORDER.TOTAL' | translate }}</span>
      <span>{{ order.total_price + (+order.tip_amount) | currencySpace }}</span>
    </div>
  </div>

    @if (orderMessage() && isPaid) {
      <div class="comment">
        <span>{{orderMessage()}}</span>
      </div>
    }

    @if (order.cta.text && isPaid) {
      <div class="text-icon-button">
        @if (order.cta.url) {
          <span (click)="openCTA()">
            {{ order.cta.text }}
          </span>
          <img class="icon-md" [src]="'link.svg' | themeSource" />
        } @else {
          <span>
            {{ order.cta.text }}
          </span>
        }
      </div>
    }

    @if (showReceiptButton && isPaid) {
      <div class="text-icon-button">
        <span (click)="openReceipt()">{{ 'ACTIONS.VIEW_RECEIPT' | translate }}</span>
        <img class="icon-lg" [src]="'receipt.svg' | themeSource" (click)="openReceipt()">
      </div>
    }
    <button class="btn" data-testid="order-confirmation-close" (click)="close()">
      {{ (isPaid ? 'ACTIONS.AWESOME' : 'ACTIONS.CONTINUE') | translate }}
    </button>
</div>


